import { IParticipantModel } from 'entities/competitions-b2cr';
import { ColumnConfigType } from 'shared/types';

export const competitionParticipantsColumnConfig: ColumnConfigType<IParticipantModel>[] = [
  {
    dataFieldName: 'user_id',
    name: 'UserID',
    width: '10%',
  },
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '10%',
  },
  {
    dataFieldName: 'title',
    name: 'Имя',
    width: '25%',
  },
  {
    dataFieldName: 'place',
    name: 'Место',
    width: '10%',
  },
  {
    dataFieldName: 'created_at',
    name: 'Дата создания',
    width: '20%',
  },
  {
    dataFieldName: 'purchase_amount',
    name: 'Сумма баллов',
    width: '15%',
  },
  {
    dataFieldName: 'purchase_amount_today',
    name: 'Баллов сегодня',
    width: '15%',
  },
];
